<template>
  <div class="over_layout">
    <section class="edit_cv">
      <div class="wrapper">
        <div class="edit_block">
          <div class="cv_chang_area">
            <div class="cv_craft" id="cv_craft" v-if="$store.state.loadEditCv" ref="cvCraft">
              <div class="wathermaker"></div>
              <div :class='$store.state.cv.cvTheme.class_name' id='cv_standard_1'>
                <div class='bg_area'>
                  <div class='cv_them_top_cv_block'>
                    <div class='cv_them_left_img_name_block'>
                      <div class='cv_them_img_block'>
                        <img
                          :src="$store.state.cv.photo || '/vue/images/user_img.jpg'"
                          @click="$store.commit('uploadPhotoCv', true)"
                        >
                      </div>
                    </div>
                    <div class='cv_them_right_block'>
                      <div class='cv_them_block' @click="openTab('info')">
                        <div class='cv_them_name_block'>{{
                          $store.getters.cv_t('career_objective') }}
                        </div>
                        <p
                          v-html="$store.getters.career_objective('Test carear')"
                        ></p>
                      </div>
                      <div class='cv_them_block'>
                        <div class='cv_them_name' @click="openTab('info')">
                          {{ $store.state.cv.name || 'Name' }} {{ $store.state.cv.surname ||
                          "Surname" }}
                        </div>
                        <div class='cv_them_profession' @click="openTab('professions')">
                          {{ $store.getters.cvProfessions || $store.getters.cv_t('profession')
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class='cv_them_all_blocks'>
                    <div class='cv_them_left_block small_section'>
                      <div class='cv_them_block'>
                        <div class='cv_them_name_block' @click="openTab('info')">{{
                          $store.getters.cv_t('conditions') }}
                        </div>
                        <ul>
                          <li class='cv_them_pro_Conditions1_1' @click="openTab('info')">
                            {{ $store.state.cv.date ? correctDate($store.state.cv.date) :
                            '2019-01-01'}}
                          </li>
                          <li class='cv_them_pro_Conditions1_2' @click="openTab('job-stack')">
                            {{ $store.state.cv.jobStack.title ||
                            $store.getters.cv_t('full_stack') }}
                          </li>
                          <li class='cv_them_pro_Conditions1_3' @click="openTab('job-stack')">
                            <template v-if="$store.state.cv.jobStack.sallery">
                              {{ $store.getters.cv_t('from')}}
                              <span>
                                              {{ XFormatPrice($store.state.cv.jobStack.sallery) }}
                                              <span
                                                v-if="$store.state.cv.jobStackPlus"
                                              >+</span>
                                            </span>
                              {{ $store.state.cv.jobStackCurrency.symbol}}
                            </template>
                            <template v-else>
                              <span>{{ $store.getters.cv_t('contractual')}}</span>
                            </template>
                          </li>
                        </ul>
                      </div>
                      <div class='cv_them_block'>
                        <div class='cv_them_name_block' @click="openTab('contacts')">
                          {{ $store.getters.cv_t('contacts') }}
                        </div>
                        <ul>
                          <li class='cv_them_pro_tel' @click="openTab('contacts')">
                            <a
                              :href="`tel:${$store.state.cv.phone || '+37422222222'}`"
                            >{{$store.state.cv.phone || "+37422222222"}}</a>
                          </li>
                          <li class='cv_them_pro_mail' @click="openTab('contacts')">
                            <a
                              :href="`mailto:${$store.state.cv.email || 'example@email.com'}`"
                            >{{$store.state.cv.email || 'example@email.com'}}</a>
                          </li>
                          <li @click="openTab('contacts')" class='cv_them_pro_address'>{{
                            $store.state.cv.address.address ||
                            $store.getters.cv_t('address') }}
                          </li>

                          <template v-if="$store.state.cv.hasSocial">
                            <li class='cv_them_pro_soc' @click="openTab('social')"
                                v-if="$store.state.cv.tmpSocial.url || !$store.state.cv.cvSocials.length"
                                :class="$store.state.cv.tmpSocial.class_name">
                                             <span>
                                                <a :href="$store.state.cv.tmpSocial.url || '#'" target="_blank">
                                                    {{ $store.state.cv.tmpSocial.url ?
                                                    convertSocial($store.state.cv.tmpSocial.url) :
                                                    'facebook'}}
                                                </a>
                                             </span>
                            </li>

                            <li @click="openTab('social')" class='cv_them_pro_soc'
                                v-for="(icon, index) in $store.state.cv.cvSocials"
                                :key="'icon'+index"
                                :class="icon.class_name">
                              <a :href="icon.url" target="_blank">
                                {{ convertSocial( icon.url, icon.icon ) }}
                              </a>
                            </li>
                          </template>
                        </ul>
                      </div>
                      <div class='cv_them_block' @click="openTab('skills')">
                        <div class='cv_them_name_block'>
                          {{$store.getters.cv_t("skills")}}
                        </div>
                        <div class='cv_them_list'>
                          <ul data-name="cvSkills">
                            <li v-for="skill in $store.state.cv.cvSkills"
                                :key="'skill'+skill.id+key"
                                :class="lineBr(skill)"
                            >
                              <div class='cv_them_skill_percent'>
                                <div class='cv_them_skill'>{{ skill.title }}</div>
                                <div class='cv_them_stars'>
                                  <div :class="skill.percent > 19 ? 'active' : ''"></div>
                                  <div :class="skill.percent > 39 ? 'active' : ''"></div>
                                  <div :class="skill.percent > 59 ? 'active' : ''"></div>
                                  <div :class="skill.percent > 79 ? 'active' : ''"></div>
                                  <div :class="skill.percent > 99 ? 'active' : ''"></div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class='cv_them_block' @click="openTab('languages')">
                        <div class='cv_them_name_block'>
                          {{$store.getters.cv_t("languages")}}
                        </div>
                        <div class='cv_them_list'>
                          <ul data-name="cvLanguages">
                            <li v-for="lang in $store.state.cv.cvLanguages"
                                :key="'lang'+lang.id+key"
                                :class="lineBr(lang)"
                            >
                              <div class='cv_them_skill_percent'>
                                <div class='cv_them_skill'>{{ lang.name }}</div>
                                <div class='cv_them_stars'>
                                  <div :class="lang.percent > 19 ? 'active' : ''"></div>
                                  <div :class="lang.percent > 39 ? 'active' : ''"></div>
                                  <div :class="lang.percent > 59 ? 'active' : ''"></div>
                                  <div :class="lang.percent > 79 ? 'active' : ''"></div>
                                  <div :class="lang.percent > 99 ? 'active' : ''"></div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class='cv_them_block' v-if="$store.state.cv.hasHobby" @click="openTab('hobby')">
                        <div class='cv_them_name_block'>
                          {{$store.getters.cv_t("hobby")}}
                        </div>
                        <ul data-name="hobbies">
                          <li
                            v-if="!$store.state.cv.hobbies.length || $store.state.cv.hobby"
                          >{{ $store.state.cv.hobby || $store.getters.cv_t("football")}}
                          </li>
                          <li
                            v-for="(hobby, index) in $store.state.cv.hobbies"
                            :key="'hobby'+index+key"
                            :class="lineBr(hobby)"
                          >{{ hobby.title }}
                          </li>
                        </ul>
                      </div>
                      <div class='cv_them_block cv_them_block_info' @click="openTab('citizen')">
                        <div class='cv_them_name_block'>{{ $store.getters.cv_t('citizen')}}</div>
                        <ul data-name="cvCitizens">
                          <li v-for="(citizen,index) in $store.state.cv.cvCitizens"
                              :key="'citizen'+citizen.id+key+index"
                              :class="lineBr(citizen)"
                          >
                            {{citizen.title}}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class='cv_them_right_block large_section'>
                      <div class="cv_them_block" data-type='educations' @click="openTab('education')">
                        <div class='cv_them_name_block large_section_title'>{{ $store.getters.cv_t('education') }}
                        </div>

                        <div class="cv_them_block_item large_section_line"
                             v-if="isTmpEducation()">
                          <div class='cv_them_block_dates_info'>
                            <div class='cv_them_dates'>
                              {{ correctDate(tmpEducation.start, {month: true}) ||
                              '2016.10'}} -
                              {{ correctDate(tmpEducation.end, {month: true}) ||
                              $store.getters.cv_t("present") }}
                            </div>
                            <span>{{ tmpEducation.location.address || $store.getters.cv_t("location") }}</span>
                            <span>{{ tmpEducation.university || $store.getters.cv_t("university")}}</span>
                          </div>
                          <div class='cv_them_specialty'>{{ tmpEducation.faculty ||
                            $store.getters.cv_t("faculty")}},
                            {{ tmpEducation.specialization.title ||
                            $store.getters.cv_t("specialization")}},
                            {{ tmpEducation.degree.title || $store.getters.cv_t("degree")}}
                          </div>
                          <p
                            v-html="tmpEducation.description.replace(/(?:\r\n|\r|\n)/g, '<br />') || $store.getters.cv_t('description')"
                          ></p>
                        </div>

                        <div class="cv_them_block_item large_section_line"
                             v-for="(education, index) in $store.state.cv.educations"
                             :key="'education'+index">
                          <div class='cv_them_block_dates_info'>
                            <div class='cv_them_dates'>
                              {{ correctDate(education.start, {month: true}) }} -
                              {{ correctDate(education.end, {month: true})
                              || $store.getters.cv_t("present") }}
                            </div>
                            <span>{{ education.location.address }}</span>
                            <span>{{ education.university }}</span>
                          </div>
                          <div class='cv_them_specialty'>{{ education.faculty }}, {{
                            education.specialization.title }}, {{
                            education.degree.title }}
                          </div>
                          <p
                            v-html="education.description ? education.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''"
                          ></p>
                        </div>
                      </div>

                      <div class="cv_them_block" data-type='experiences' v-if="$store.state.cv.hasExperience"
                           @click="openTab('experience')">
                        <div class='cv_them_name_block large_section_title'>{{
                          $store.getters.cv_t('work_experience') }}
                        </div>

                        <div class='cv_them_block_item large_section_line'
                             v-if="isTmpExperience()">
                          <div class='cv_them_block_dates_info'>
                            <div class='cv_them_dates'>{{ correctDate(tmpExperience.start,
                              {month: true})
                              || '2016.10'}}
                              -
                              {{ correctDate(tmpExperience.end, {month: true}) ||
                              $store.getters.cv_t("present") }}
                            </div>
                            <span>{{ tmpExperience.location.address || $store.getters.cv_t("location") }}</span>
                            <span>{{ tmpExperience.company || $store.getters.cv_t("company")}}</span>
                          </div>
                          <div class='cv_them_specialty'>{{ tmpExperience.specialization.title
                            ||
                            $store.getters.cv_t("specialization")}}
                          </div>
                          <p
                            v-html="tmpExperience.description.replace(/(?:\r\n|\r|\n)/g, '<br />') || $store.getters.cv_t('description')"
                          ></p>
                        </div>

                        <div class='cv_them_block_item large_section_line'
                             v-for="(experience, index) in $store.state.cv.experiences"
                             :key="'exp' + index">
                          <div class='cv_them_block_dates_info'>
                            <div class='cv_them_dates'>{{ correctDate(experience.start,
                              {month: true}) }}
                              -
                              {{ correctDate(experience.end, {month: true}) ||
                              $store.getters.cv_t("present") }}
                            </div>
                            <span>{{ experience.location.address }}</span>
                            <span>{{ experience.company }}</span>
                          </div>
                          <div class='cv_them_specialty'>{{ experience.specialization.title
                            }}
                          </div>
                          <p
                            v-html="experience.description ?
                                                experience.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''">
                          </p>
                        </div>
                      </div>
                      <div class="logo">
                        <a href="https://cvweb.ru" target="_blank">
                          <img src="/vue/images/cv_logo_cv.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button_download_icon">
              <div @click="save()" v-if="!$route.name.match(/cv-edit/)">
                <img
                  src="/vue/images/bg_save_btn.png"
                  width="62"
                  height="62"
                  :title="$store.getters.t('save')"
                >
              </div>
              <div @click="edit($route.params.cv)" v-else>
                <img
                  src="/vue/images/bg_save_btn.png"
                  width="62"
                  height="62"
                  :title="$store.getters.t('update')"
                >
              </div>
            </div>
          </div>
          <tools ref="tools"></tools>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import CvFunctions from "../../../cv-functions.js";
  import ResizeStyle from "../../../../../../mixins/cv-resize.js";
  import tools from "../../../tools/tools_standard";

  export default {
    mixins: [CvFunctions, ResizeStyle],
    components: {
      tools
    },
    mounted() {
      if (this.$route.name.match(/cv-create/)) {
        this.$store.commit("loadEditCv", true);
      }
    },
    updated() {
      setTimeout(() => {
        this.checkCvPage();
        this.checkCvPageLargeContent();
        this.checkPageTitle();
      }, 0.1);
    }
  };
</script>

<style lang="scss" scoped>
  @import url("/vue/templates/cv_standard_1.css");
  .logo{
    position: absolute;
    bottom: 15px;
    right: 15px;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/templates/standard/s-1/cv-action.vue